<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'moi.findingReportSummary.cardTitle' | transloco }}</div>
    <div class="detail-page-card-actions">
        @if (showOpenButton) {
            @if (summaryModel.guid) {
                <button class="btn btn-raised" (click)="openFindingReport()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'moi.findingReportSummary.openFindingReportBtn' | transloco }}</span>
                </button>
            }
            @if (assessmentModel) {
                <button class="btn btn-raised" (click)="openAssessment()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'moi.findingReportSummary.openAssessmentBtn' | transloco }}</span>
                </button>
            }
        }
    </div>

    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        <div class="row">
            @if (summaryModel) {
                <div class="col-12 col-xl-6 left-block">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.findingReportSummary.reportNameLabel' | transloco }}</label>
                                <input
                                    data-uiid="bim-moi-report-name"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.objectName"
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.findingReportSummary.typeLabel' | transloco }}</label>
                                <input
                                    data-uiid="bim-moi-report-type"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.type"
                                    inputTooltip
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.findingReportSummary.reportNoLabel' | transloco }}</label>
                                <input
                                    data-uiid="bim-moi-report-no"
                                    type="text"
                                    class="form-control form-control-sm"
                                    disabled
                                    [value]="summaryModel.reportNo"
                                    inputTooltip
                                />
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label>{{ 'moi.findingReportSummary.overallScoreLabel' | transloco }}</label>
                                <ng-select
                                    data-uiid="bim-moi-overall-score"
                                    [items]="[
                                        {
                                            Id: 1,
                                            Name: summaryModel.scoreTypeName,
                                            Color: summaryModel.scoreTypeColor,
                                        },
                                    ]"
                                    [ngModel]="1"
                                    bindLabel="Name"
                                    bindValue="Id"
                                    disabled
                                >
                                    <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                        <div
                                            [style.background-color]="item.Color"
                                            style="
                                                min-width: 5px;
                                                min-height: 16px;
                                                float: left;
                                                margin-right: 10px;
                                            "
                                        ></div>
                                        {{ item.Name }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>{{ 'moi.findingReportSummary.reportDateLabel' | transloco }}</label>
                        <date-input
                            data-uiid="bim-moi-report-date"
                            [(value)]="summaryModel.reportDate"
                            [disabled]="true"
                        ></date-input>
                    </div>
                    <div class="form-group">
                        <label>{{ 'moi.findingReportSummary.conclusionLabel' | transloco }}</label>
                        <textarea
                            data-uiid="bim-moi-conclusion"
                            type="date"
                            class="form-control form-control-sm"
                            disabled
                            [value]="summaryModel.conclusion"
                            inputTooltip
                        >
                        </textarea>
                    </div>

                    <hr class="d-xl-none" />
                </div>
            } @else {
                <div class="fancy-loader submodule my-4"></div>
            }

            <div class="col-12 col-xl-6 right-block">
                @if (moi && !assessmentIsLoading) {
                    <div>
                        @if (!moi.AssessmentGuid) {
                            @if (assessments && assessments.length > 0) {
                                <div>
                                    <div class="form-group">
                                        <label for="subjectSelect">{{ 'moi.findingReportSummary.availableAssessmentLabel' | transloco }}</label>
                                        <div class="row me-0">
                                            <div class="col-8">
                                                <ng-select
                                                    id="assessmentSelect"
                                                    name="assessmentSelect"
                                                    [items]="assessments"
                                                    bindLabel="assessmentType"
                                                    bindValue="guid"
                                                    (change)="change($event)"
                                                    [ngModel]
                                                    [disabled]="!canLink"
                                                >
                                                    <ng-template
                                                        ng-label-tmp
                                                        ng-option-tmp
                                                        let-item="item"
                                                    >
                                                        <div
                                                            [style.background-color]="
                                                                item.scoreColor
                                                            "
                                                            style="
                                                                min-width: 5px;
                                                                min-height: 16px;
                                                                float: left;
                                                                margin-right: 10px;
                                                            "
                                                        ></div>
                                                        {{ item.assessmentType }} ({{
                                                            item.date | dateFormat
                                                        }})
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                            @if (canLink) {
                                                <button
                                                    class="btn btn-success btn-sm col me-2"
                                                    (click)="linkAssessment()"
                                                    [disabled]="!assessmentModel"
                                                    matTooltip="Link assessment to MoI"
                                                >
                                                    <i class="fas fa-link"></i>
                                                </button>
                                            }
                                            <button
                                                class="btn btn-info btn-sm col"
                                                (click)="load()"
                                                matTooltip="Reload assessments"
                                            >
                                                <i class="fas fa-sync-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            } @else {
                                <div>
                                    <div class="text-center">
                                        <h6>{{ 'moi.findingReportSummary.noAssessmentsAvailable' | transloco }}</h6>
                                        <small class="text-muted">{{ 'moi.findingReportSummary.noAssessmentsHelp' | transloco }}</small>
                                    </div>
                                </div>
                            }
                        }

                        @if (assessmentModel && assessmentModel.guid) {
                            <div>
                                @if (!moi.AssessmentGuid) {
                                    <div>
                                        <hr />
                                        <div class="row text-center">
                                            <i
                                                class="fas fa-exclamation-triangle text-warning col-1 flex-center"
                                            ></i>
                                            <small class="col">
                                                This is only a preview of the assessment. Click '
                                                <i class="fas fa-link"></i> ' to make it permanent!
                                            </small>
                                            <i
                                                class="fas fa-exclamation-triangle text-warning col-1 flex-center"
                                            ></i>
                                        </div>
                                        <hr />
                                    </div>
                                }
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label>{{ 'moi.findingReportSummary.assessmentTypeLabel' | transloco }}</label>
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                disabled
                                                [value]="assessmentModel.assessmentType"
                                                inputTooltip
                                            />
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label>{{ 'moi.findingReportSummary.assessmentScoreLabel' | transloco }}</label>
                                            <ng-select
                                                [items]="[
                                                    {
                                                        Id: 1,
                                                        Name: assessmentModel.scoreName,
                                                        Color: assessmentModel.scoreColor,
                                                    },
                                                ]"
                                                [ngModel]="1"
                                                bindLabel="Name"
                                                bindValue="Id"
                                                disabled
                                            >
                                                <ng-template
                                                    ng-label-tmp
                                                    ng-option-tmp
                                                    let-item="item"
                                                >
                                                    <div
                                                        [style.background-color]="item.Color"
                                                        style="
                                                            min-width: 5px;
                                                            min-height: 16px;
                                                            float: left;
                                                            margin-right: 10px;
                                                        "
                                                    ></div>
                                                    {{ item.Name }}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{ 'moi.findingReportSummary.commentLabel' | transloco }}</label>
                                    <textarea
                                        type="date"
                                        class="form-control form-control-sm"
                                        disabled
                                        [value]="assessmentModel.comments"
                                        inputTooltip
                                    >
                                    </textarea>
                                </div>
                                <div class="form-group">
                                    <label>{{ 'moi.findingReportSummary.assessmentDateLabel' | transloco }}</label>
                                    <date-input
                                        [(value)]="assessmentModel.date"
                                        [disabled]="true"
                                    ></date-input>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="fancy-loader submodule my-4"></div>
                }
            </div>
        </div>
    </div>
</div>
